import React, { PureComponent } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import { FormControl } from 'components/form';
import { Grid } from 'components/grid';
import { I18n } from 'components/translate';
import Settings from 'configs/Settings';
import { inject } from 'mobx-react';
import PropTypes from 'prop-types';

import OfferPanelRadioList from '../../OfferPanelRadioList';

import './SalesInfoPrice.scss';

@inject((stores) => ({
  productId: stores.MembershipStore.productId
}))
class SalesInfoPrice extends PureComponent {
  static propTypes = {
    selectedOffers: PropTypes.array,
    offers: PropTypes.array,
    productId: PropTypes.number,
    allowUncheck: PropTypes.bool,
    onUncheckItem: PropTypes.func,
    onCheckItem: PropTypes.func,
    className: PropTypes.string
  };

  labelPath = 'sales_manager.sales_info.price';

  get className() {
    const { className } = this.props;

    return classnames('sales_info_price', className);
  }

  get offerLink() {
    const { productId } = this.props;

    return `${Settings.app.bw}/products/manage/${productId}/offers`;
  }

  render() {
    const { selectedOffers, offers, allowUncheck, onUncheckItem, onCheckItem } =
      this.props;

    return (
      <Grid className={this.className} block>
        <Grid.Title data-test="grid-title">
          <I18n label="general.price" />
        </Grid.Title>
        <p data-test="grid-description" className="sales_info__description">
          <I18n label={`${this.labelPath}.description`} />
          <br />
          <I18n label={`${this.labelPath}.info`} />{' '}
          <a
            className="_text-blue-dark"
            target="_blank"
            rel="noreferrer noopener"
            href={this.offerLink}
          >
            <I18n label={`${this.labelPath}.info_link`} />
            <FontAwesomeIcon
              icon={['fal', 'external-link']}
              className="_ml-2"
            />
          </a>
        </p>
        <FormControl data-test="offer-panel">
          <OfferPanelRadioList
            className="sales_info_price__offer"
            required
            name="offersRadioList"
            value={selectedOffers}
            panelLabel="sales_manager.sales_info.choose_offer"
            items={offers}
            allowUncheck={allowUncheck}
            selectedOffers={selectedOffers}
            onUncheckItem={onUncheckItem}
            onCheckItem={onCheckItem}
          />
        </FormControl>
      </Grid>
    );
  }
}

export default SalesInfoPrice;
